import { ShopStatus } from 'app/api/@generated/backend';

import { ShopStatusService } from 'app/pages/order/services/shop-status-service';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';

export const fetchShopStatusActionCreator = createAppAsyncThunk<ShopStatus>(
    'order/fetchShopStatus',
    async () => ShopStatusService.getShopStatus(),
    {
        getPendingMeta: () => ({ requestType: RequestType.GET_SHOP_STATUS }),
    },
);
